import { useLanguage } from "@/contexts/LanguageContext";
import { SearchBar } from "@/components/search/SearchBar";

export function HeroSection() {
  const { t } = useLanguage();

  return (
    <section
      id="hero-search"
      className="relative pt-28 pb-10 sm:pt-32 lg:pt-48 lg:pb-0"
      style={{ background: "linear-gradient(180deg,#fff 0%,#FFF8EA 60%,#fff 100%)" }}
    >
      {/* Decorative rings */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="hidden lg:block absolute top-[-60px] right-[-90px] w-[320px] h-[320px] rounded-full border-[24px] border-[#EEEFF9]" />
        <div className="hidden lg:block absolute bottom-[-80px] right-[130px] w-[280px] h-[280px] rounded-full border-[20px] border-[#FFF1D6]" />
      </div>

      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-[1.1fr_0.9fr] gap-10 lg:gap-20 items-center">

          {/* ── Left ── */}
          <div className="flex flex-col items-center text-center lg:items-start lg:text-left">

            {/* Headline */}
            <h1 className="font-sans text-[2.25rem] sm:text-5xl lg:text-[3.75rem] font-semibold text-[#262A7A] leading-[1.1] tracking-tight mb-5">
              {t("hero.headline1")}{" "}
              <span className="relative inline-block pb-3">
                {t("hero.headline2")}
                <svg className="absolute bottom-0 left-0 w-full h-[14px]" viewBox="0 0 300 20" fill="none" preserveAspectRatio="none" aria-hidden="true">
                  <path d="M6 9 C 80 3, 220 3, 294 9" stroke="#F7B030" strokeWidth="2.5" strokeLinecap="round" />
                  <path d="M22 16 C 90 11, 210 11, 278 16" stroke="#F29F05" strokeWidth="1.5" strokeLinecap="round" opacity="0.65" />
                </svg>
              </span>
            </h1>

            {/* Sub-headline */}
            <p className="text-[#5A5E80] text-lg leading-relaxed max-w-md mb-10">
              {t("hero.subheadline")}
            </p>

            {/* GIF — mobile only */}
            <div className="block lg:hidden w-full mb-10">
              <div className="w-full aspect-video rounded-2xl overflow-hidden shadow-md border border-[#DCDDEE]">
                <img
                  src="/bookmycoaching-why-us.gif"
                  alt="BookMyCoaching — connect with expert tutors"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            {/* Search bar */}
            <div className="relative z-20 w-full mb-5">
              <SearchBar />
            </div>

            {/* Subtle trust line */}
            <p className="text-sm text-[#A9ACD6]">
              Free to search &middot; Verified teachers &middot; No signup needed to browse
            </p>

          </div>

          {/* ── Right: GIF — desktop only ── */}
          <div className="hidden lg:block">
            <div className="w-full aspect-video rounded-3xl overflow-hidden shadow-xl border border-[#DCDDEE]">
              <img
                src="/bookmycoaching-why-us.gif"
                alt="BookMyCoaching — connect with expert tutors"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
